import React from "react";

const TestimonialFive = () => {
  return (
    <>
      {/* =================== Testimonial Five Start ===================*/}
      <div
        className="testimonial-area bg-left-50 pd-top-120 pd-bottom-90"
        style={{ backgroundImage: 'url("assets/img/testi.webp")' }}
      >
        <div className="row">
          <div className="col-xl-5 col-lg-7 offset-xl-5 offset-lg-4">
            <div className="bg-white box-shadow border-radius-5 p-xl-5 p-4">
              <div className="section-title">
                <h6 className="sub-title-sky-blue">客户回馈</h6>
                <h2 className="title">智能化的受益者</h2>
              </div>
              <ul
                className="nav testimonial-tab nav-tabs"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home"
                    type="button"
                    role="tab"
                    aria-controls="home"
                    aria-selected="true"
                  >
                    <img src="assets/img/testimonial/p1.webp" alt="img" />
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#profile"
                    type="button"
                    role="tab"
                    aria-controls="profile"
                    aria-selected="false"
                  >
                    <img src="assets/img/testimonial/p2.webp" alt="img" />
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="contact-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#contact"
                    type="button"
                    role="tab"
                    aria-controls="contact"
                    aria-selected="false"
                  >
                    <img src="assets/img/testimonial/p3.webp" alt="img" />
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <h4 className="pt-xl-5 pt-4">Isabella Rodriguez</h4>
                  <p>首席财务官</p>
                  <p className="pb-0 border-top-1 pt-3 mt-3">
                    AI解决方案使我们的财务分析更精确和高效。我们能够更好地预测财务趋势，做出更明智的投资决策。
                  </p>
                </div>
                <div
                  className="tab-pane fade"
                  id="profile"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <h4 className="pt-xl-5 pt-4">Emma Johnson</h4>
                  <p>市场总监</p>
                  <p className="pb-0 border-top-1 pt-3 mt-3">
                    大数据分析工具帮助我们更好地了解客户需求。这使得我们的市场活动更具针对性，提高了市场营销的效果。
                  </p>
                </div>
                <div
                  className="tab-pane fade"
                  id="contact"
                  role="tabpanel"
                  aria-labelledby="contact-tab"
                >
                  <h4 className="pt-xl-5 pt-4">Emily Parker</h4>
                  <p>客户服务经理</p>
                  <p className="pb-0 border-top-1 pt-3 mt-3">
                    AI支持中心对客户体验的改进。现在我们能够更快速地响应客户查询，提供更个性化的支持，增加了客户满意度和忠诚度。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =================== Testimonial Five End ===================*/}
    </>
  );
};

export default TestimonialFive;
